export const CARD_ISSUE_SUCCESS_ANIMATION_FILE_PATH = 'assets/animations/success_card_issuing.json';
